import departureCity from '@/js/common/Domain/Hydrator/fromRouter/departureCity';
import resorts from '@/js/common/Domain/Hydrator/fromRouter/resorts';
import checkInDateRange from '@/js/common/Domain/Hydrator/fromRouter/checkInDateRange';
import directFlights from '@/js/common/Domain/Hydrator/fromRouter/directFlights';
import warranted from '@/js/common/Domain/Hydrator/fromRouter/warranted';
import isExclusive from '@/js/common/Domain/Hydrator/fromRouter/isExclusive';
import nightRange from '@/js/common/Domain/Hydrator/fromRouter/nightRange';
import touristGroup from '@/js/common/Domain/Hydrator/fromRouter/touristGroup';
import hotelCategories from '@/js/common/Domain/Hydrator/fromRouter/hotelCategories';
import meals from '@/js/common/Domain/Hydrator/fromRouter/meals';

import '@/js/common/plugins/jquery.unparam.min';

export default (urlParams) => {
    if (typeof urlParams !== 'string') {
        return null;
    }

    const params = $.unparam(urlParams);

    const tourCriteria = {
        ...departureCity(params),
        ...resorts(params),
        ...checkInDateRange(params),
        ...nightRange(params),
        ...touristGroup(params),
        ...hotelCategories(params),
        ...meals(params),
        ...directFlights(params),
        ...warranted(params),
        ...isExclusive(params),
        countries: [76],
    };

    if (!tourCriteria.resorts) {
        const defaultResort = window?.appConfig?.defaultTourCriteria?.resorts?.[0];
        tourCriteria.resorts = defaultResort ? [defaultResort] : [];
    }

    const other = _.omit(params, 'fromCity', 'toCity', 'dateFrom', 'dateTo', 'dateFlexible', 'nightFrom', 'nightTo',
        'adults', 'children', 'ages', 'kids', 'infants', 'hotelClass', 'meal', 'directFlight', 'warranted', 'isExclusive');

    return {
        tourCriteria,
        other,
    };
};